/**
 * @flow
 * @relayHash f7454605c8c1e1b915bdb01057c193fc
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SearchableNewOwnerDropdownQueryVariables = {|
  staffName?: ?string,
  first?: ?number,
  orderBy?: ?string,
  includeInactive?: ?boolean,
  eligibleOwner?: ?boolean,
|};
export type SearchableNewOwnerDropdownQueryResponse = {|
  +staffByOrg: ?{|
    +edgeCount: ?number,
    +totalCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +fullName: ?string,
      |}
    |}>,
  |}
|};
export type SearchableNewOwnerDropdownQuery = {|
  variables: SearchableNewOwnerDropdownQueryVariables,
  response: SearchableNewOwnerDropdownQueryResponse,
|};
*/


/*
query SearchableNewOwnerDropdownQuery(
  $staffName: String
  $first: Int
  $orderBy: String
  $includeInactive: Boolean
  $eligibleOwner: Boolean
) {
  staffByOrg(staffName: $staffName, orderBy: $orderBy, first: $first, includeInactive: $includeInactive, eligibleOwner: $eligibleOwner) {
    edgeCount
    totalCount
    edges {
      node {
        id
        fullName
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "staffName",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeInactive",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "eligibleOwner",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "staffByOrg",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "eligibleOwner",
        "variableName": "eligibleOwner"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "includeInactive",
        "variableName": "includeInactive"
      },
      {
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy"
      },
      {
        "kind": "Variable",
        "name": "staffName",
        "variableName": "staffName"
      }
    ],
    "concreteType": "StaffNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "edgeCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "StaffNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SearchableNewOwnerDropdownQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchableNewOwnerDropdownQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SearchableNewOwnerDropdownQuery",
    "id": null,
    "text": "query SearchableNewOwnerDropdownQuery(\n  $staffName: String\n  $first: Int\n  $orderBy: String\n  $includeInactive: Boolean\n  $eligibleOwner: Boolean\n) {\n  staffByOrg(staffName: $staffName, orderBy: $orderBy, first: $first, includeInactive: $includeInactive, eligibleOwner: $eligibleOwner) {\n    edgeCount\n    totalCount\n    edges {\n      node {\n        id\n        fullName\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '75664a5c9b62843688ee8fd78ff4ef85';
module.exports = node;
